<div>
    <div style="width: 100%; display: flex; justify-content: space-between" class="table-head" *ngIf="this.ifNfs">
        <div class="message-box info" *ngIf="this.isExcellencePartnerMC">{{ nfsMessageExcellence }}</div>
        <div class="message-box info" *ngIf="this.isPremiumPartnerMC">{{ nfsMessagePremium }}</div>
    </div>
    <div style="display: flex; justify-content: space-between" class="table-head" *ngIf="!this.ifNfs">
        <div style="flex-grow: 2" class="inputSearchSmallStyle">
            <mat-form-field appearance="outline">
                <mat-label translate>COMMONS.SEARCH</mat-label>
                <mat-icon matPrefix [inline]="true">search</mat-icon>
                <input
                    matInput
                    [(ngModel)]="searchSubscription"
                    (keyup)="onClickApplyFilter($event)"
                    placeholder="{{ 'M_SEARCH_SUB' | translate }}"
                />
                <mat-icon matSuffix [inline]="true" (click)="clearSubscriptionSearch()" class="pointer"> close</mat-icon>
            </mat-form-field>
        </div>
    </div>

    <div *ngIf="subscriptionFound; else noSubscriptionFound">
        <table mat-table [dataSource]="dataSourceSubscription" style="width: 100%">
            <ng-container matColumnDef="DescriSub">
                <th mat-header-cell *matHeaderCellDef></th>
                <td *matCellDef="let row" style="padding: 0.5rem">
                    <div style="display: flex; justify-content: flex-start">
                        <div style="padding: 0.2rem; width: 2.5rem; vertical-align: top">
                            <div
                                class="circleTypeProduct background-orangeMagoCloud"
                                matTooltip="MagoCloud"
                                matTooltipClass="tooltip-layout"
                                *ngIf="row.InstanceOrigin != 'MW'"
                            >
                                MC
                            </div>
                            <div
                                class="circleTypeProduct background-greenMagoWeb"
                                matTooltip="MagoWeb"
                                matTooltipClass="tooltip-layout"
                                *ngIf="row.InstanceOrigin == 'MW'"
                            >
                                MW
                            </div>
                        </div>

                        <div [ngClass]="this.smallTable ? 'vertical-table' : 'horizontal-table'">
                            <div style="padding: 0.1rem">
                                <span style="font-size: 1.1rem"> {{ row.Description }}</span>
                                <div style="display: flex">
                                    <span style="color: rgba(0, 0, 0, 0.54)"> {{ row.SubscriptionKey }}</span>
                                    <span
                                        class="nrOfUser"
                                        matTooltip="{{ 'M_SUB_MNG_TOOLTIP_2' | translate }}"
                                        matTooltipClass="tooltip-layout"
                                    >
                                        {{ row.NrOfAccounts }}
                                    </span>
                                </div>
                            </div>

                            <div>
                                <span
                                    style="margin-bottom: 5px"
                                    matTooltip="{{ 'PURCHASED_DATE' | translate }}"
                                    matTooltipClass="tooltip-layout"
                                    *ngIf="row.IsRtm; else IsNotRtm"
                                    >{{ row.CreationDate | date : 'dd/MM/yyyy' }}</span
                                >
                                <ng-template #IsNotRtm>
                                    <span
                                        style="margin-bottom: 5px"
                                        matTooltip="{{ 'EDIT_SUBSCRIPTION.CREATION_DATE' | translate }}"
                                        matTooltipClass="tooltip-layout"
                                    >
                                        {{ row.CreationDate | date : 'dd/MM/yyyy' }}</span
                                    >
                                </ng-template>
                                <mat-chip-list aria-label="Fish selection" *ngIf="row.InstanceOrigin == 'ONPREM'">
                                    <mat-chip>OnPremises</mat-chip>
                                </mat-chip-list>
                            </div>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnSubscription"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnSubscription"
                class="pointer"
                (click)="onClickSetSubscription(row.SubscriptionKey)"
                [ngClass]="row.IsClicked ? 'bgBluLight' : ''"
            ></tr>
        </table>
        <mat-paginator #paginatorSubscriptions [pageSizeOptions]="[5]" [pageSizeOptions]="[5, 10, 25, 100]"> </mat-paginator>
    </div>

    <ng-template #noSubscriptionFound>
        <div>
            <table class="mat-table table-management">
                <tr class="mat-row">
                    <td class="mat-cell w-25 p-05-12"><span translate>M_SUB_NOT_FOUND</span></td>
                </tr>
            </table>
        </div>
    </ng-template>
</div>
